import { render, staticRenderFns } from "./PageLayoutEdit.vue?vue&type=template&id=d5fe8082&scoped=true&"
import script from "./PageLayoutEdit.vue?vue&type=script&lang=js&"
export * from "./PageLayoutEdit.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutEdit.vue?vue&type=style&index=0&id=d5fe8082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fe8082",
  null
  
)

export default component.exports